export class Solicitud {

  constructor(
    public esSolicitud: boolean,
    public mismoSolicitante: boolean,
    public tipoIdentificacion: string,
    public numeroIdentificacion: string,
    public tipoIdentificacionSolicitante: string,
    public numeroIdentificacionSolicitante: string,
    public nombresSolicitante: string,
    public apellidosSolicitante: string,
    public correoElectronicoSolicitante: string,
    public codigoMunicipioSolicitante: number,
    public reCaptcha: string
  ) { }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/shared/models/solicitud.ts